import React from "react"

export default class SearchHeader extends React.Component {
	
	constructor(props) {
		super(props);

		this.state = {
			query: this.props.query || ''
		}

		this.onChangeQuery = this.onChangeQuery.bind(this)
	}

	componentDidUpdate(prevProps, prevState) {
		if ( (prevProps.sort !== this.props.sort) || (prevProps.page !== this.props.page)) {
			this.props.setLoading(true);
			this.refs.form.submit();
		}
	}

	render() {
		return (
			<div className="search-header">
				<form method="get" action={this.props.search_path}  ref="form">
				<h1>Search Results</h1>
				<div className="search-and-close">
					<div className="search-bar">
						<span className="fa fa-search"></span>
						<input type="search" name="q" value={this.state.query} onChange={this.onChangeQuery} />
						{this.props.query !== this.state.query ? null : <input type="hidden" ref="s" name="s" value={this.props.sort} />}
						{this.props.query !== this.state.query ? null : <input type="hidden" ref="p" name="p" value={this.props.page} />}
					</div>
					<a href={this.props.my_courses_path || this.props.all_courses_path} className="close-button">Close</a>
				</div>
				</form>
			</div>
		)
	}

	onChangeQuery(e) {
		this.setState({query: e.target.value});
	}

}